import {Box, InputBase, styled, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {ReactComponent as AddIcon} from '../../../../../assets/icons/add.svg';
import {ReactComponent as SubtractIcon} from '../../../../../assets/icons/subtract.svg';
import IconButton from '../../../../common/IconButton';

const InputBaseStyled = styled(InputBase)(() => ({
  '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
    display: 'none',
  },
  '& input[type=number]': {
    MozAppearance: 'textfield',
  },
  '& input': {
    textAlign: 'center',
  },
}));

type SteamInjectionNumberRowProps = {
  steamInjectionDuration: number;
  onChange: (steamInjectionDuration: number) => void;
};

function SteamInjectionNumberRow(props: SteamInjectionNumberRowProps) {
  const {steamInjectionDuration, onChange} = props;
  const {t} = useTranslation();

  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', gap: '16px'}}>
      <Box>
        <Typography
          sx={{fontSize: '20px', fontStyle: 'normal', fontWeight: 500, lineHeight: '28px'}}>
          {t('recipe_settings_phases_steam_injection_duration_label')}
        </Typography>
        <Typography
          sx={{
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px',
            color: 'custom.textTertiary',
          }}>
          {t('recipe_settings_phases_steam_injection_duration_message')}
        </Typography>
      </Box>
      <InputBaseStyled
        sx={{
          width: '96px',
          fontSize: '20px',
          fontStyle: 'normal',
          fontWeight: 400,
          lineHeight: '28px',
          '& .Mui-disabled': {
            color: 'custom.textPrimary',
            WebkitTextFillColor: (theme) => theme.palette.custom.textPrimary,
          },
        }}
        value={steamInjectionDuration}
        disabled
        startAdornment={
          steamInjectionDuration === 0 ? (
            <Box sx={{minWidth: '32px'}} />
          ) : (
            <IconButton
              IconComponent={SubtractIcon}
              onClick={() => onChange(steamInjectionDuration - 1)}
            />
          )
        }
        endAdornment={
          steamInjectionDuration === 4 ? (
            <Box sx={{minWidth: '30px'}} />
          ) : (
            <IconButton
              IconComponent={AddIcon}
              onClick={() => onChange(steamInjectionDuration + 1)}
            />
          )
        }
      />
    </Box>
  );
}

export default SteamInjectionNumberRow;
